export default "__VITE_ASSET__CPdEhArk__"